import {
  AddToShoppingCartSource,
  ICollection,
  IProduct,
} from '@monofront/types';
import CarouselProducts from '@components/CarouselProducts';
import { useTranslations } from 'next-intl';
import {
  IPrismicCustomTypeContent,
  SlicesContainer,
} from '@screens/SlicesContainer';
import {
  SiblingCollectionsCardList,
  Description,
  GoBackLink,
  CollectionBreadcrumb,
  CollectionHubTreeCards,
  HeroCollectionHub,
} from '@screens/Collection/components';
import { useHits } from 'react-instantsearch-core';

export interface ICollectionHubPrismicContent {
  slices: IPrismicCustomTypeContent[];
}

interface ICollectionHubProps {
  collection: ICollection;
  siblingCollections?: ICollection[] | null;
  collectionHubPrismicContent?: ICollectionHubPrismicContent;
}

export const CollectionHub: React.FC<ICollectionHubProps> = ({
  collection,
  siblingCollections,
  collectionHubPrismicContent,
}) => {
  const tCatalog = useTranslations('Catalog');
  const { hits } = useHits<IProduct>();

  return (
    <div className="tw-pb-12">
      <GoBackLink
        currentPathTitle={collection.title}
        breadcrumb={collection.breadcrumb}
        UNSAFE_className="desktop:tw-hidden tw-px-3 tw-py-4"
      />
      <div className="limited-width-container tw-hidden tw-py-4 desktop:tw-block">
        <CollectionBreadcrumb
          currentPathTitle={collection.title}
          breadcrumb={collection.breadcrumb}
        />
      </div>
      <div className="limited-width-container tw-px-3 tw-pb-4 tw-pt-2 desktop:tw-px-0 desktop:tw-pb-8">
        <HeroCollectionHub
          title={collection.title}
          image={collection.image}
          descriptionHtml={collection.short_description}
        />
      </div>
      <div className="tw-bg-beige-200 tw-px-3 tw-py-4 desktop:tw-py-12">
        <div
          className="limited-width-container tw-flex tw-flex-row tw-flex-wrap tw-justify-center tw-gap-3 desktop:tw-justify-start desktop:tw-gap-10"
          data-testid={`Tree cards of the collection ${collection.title}`}
        >
          <CollectionHubTreeCards collection={collection} />
        </div>
      </div>
      {collectionHubPrismicContent?.slices.length ? (
        <SlicesContainer pageContents={collectionHubPrismicContent.slices} />
      ) : null}
      <div className="tw-px-3 tw-pt-12">
        <div className="limited-width-container tw-flex tw-flex-col tw-gap-12">
          {collectionHubPrismicContent?.slices.length ? null : (
            <div>
              <CarouselProducts
                headerTitle={
                  <h2 className="tw-lf-title-md">
                    {tCatalog('essentialOfShelve', {
                      shelve: collection.title,
                    })}
                  </h2>
                }
                products={hits.slice(0, 20)}
                containerContext={{
                  source: AddToShoppingCartSource.CAROUSEL,
                }}
              />
            </div>
          )}
          <SiblingCollectionsCardList siblingCollections={siblingCollections} />
          <Description
            description={collection.body_html}
            dataTestId="Collection hub long description"
          />
        </div>
      </div>
    </div>
  );
};
